import * as serverApi from './server'

export const createTag = ({ name, color, projectId }) => serverApi.post('/v3/tags', { name, color, projectId })
export const getAll = (queryParams) => serverApi.get('/v3/tags', queryParams)
export const editUrls = (payload) => serverApi.patch('/v3/tags/urls', payload)
export const deleteTags = (payload) => serverApi.post('/v3/tags/remove', payload)
export const editProducts = (payload) => serverApi.patch('/v3/tags/products', payload)
